import { createScenarioStub } from "../scenarioFlow/ScenarioFlowStub";
import { ROUTES } from "../../utils/constants";

export default createScenarioStub({
	scenarioNum: 4,
	kind: "quiz",
	label: "Pregunta 4 (plantilla)",
	nextRoute: ROUTES.SCENARIO4_FIN,
});
